import {Navigate, createFileRoute} from "@tanstack/react-router";

export const Route = createFileRoute("/_app/sales/offers/$offerId/details/")({
  component: RouteComponent,
});
function RouteComponent() {
  const {offerId} = Route.useParams();
  return <Navigate replace to="/sales/offers/$offerId" params={{offerId}} />;
}
